import React, {Component} from 'react';
import {FilePond, registerPlugin} from "react-filepond";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond/dist/filepond.min.css";
import {urlConfig} from "../config";
import showSnackBar from "../Utilities/SnackbarHelper";
import {ERROR, SUCCESS} from "../constants";
import {withSnackbar} from 'notistack';
// Register the plugins
registerPlugin( FilePondPluginFileValidateType, FilePondPluginFileValidateSize);

class ExcelUploader extends Component {

    constructor(props) {
        super(props);



        this.state = {
            files: props.files,
            inputName:props.inputName,
            label: props.label
        };



        let self = this;
        this.serverConfig =
            {
                url: `${urlConfig.contextServiceUrl}bulkUpload/upload/description`,
                process: {
                    method: 'POST',
                    timeout: 60000,
                    onload: (response) => {
                        if (response) {
                            response = JSON.parse(response);
                            if (response) {
                                // showSnackBar(response,SUCCESS,self)
                            }else{
                                showSnackBar("The file could not be uploaded. Please retry.",ERROR,self)
                            }
                        }
                    },
                    ondata: ((formData) => {
                        formData.append('userName', sessionStorage.userName);
                        return formData;
                    }),
                    onerror: null
                }
            }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.files !== this.state.files) {
            this.setState({files: nextProps.files})
        }
    }


    handleInit = () => {

    };

    render() {


        const uploaderStyle={
            // marginTop: '1em'
        };

        return (<FilePond ref={ref => this.pond = ref} style={uploaderStyle}
                          name={"descriptionBulkUploadFile"}
                          allowMultiple={false}
                          maxFiles={1}
                          allowFileTypeValidation={false}
                          maxFileSize={'50MB'}
                          allowFileSizeValidation={true}
                          acceptedFileTypes={['.xls,.xlsx']}
                          server={this.serverConfig}
                          oninit={() => this.handleInit()}
                          labelIdle={this.state.label}
                          allowRevert={false}
                          allowReplace={false}
                          allowBrowse={true}
                          allowDrop={true}
                          allowPaste={true}
        >


        </FilePond>)
    }
}

export default withSnackbar(ExcelUploader)

